import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";

Vue.use(VueRouter);

// group-pages
const Home = () => import(/* webpackChunkName: "group-pages" */ "./views/Home");
const EventCode = () => import(/* webpackChunkName: "group-pages" */ "./views/EventCode");
const Features = () => import(/* webpackChunkName: "group-pages" */ "./views/Features");
const Advantages = () => import(/* webpackChunkName: "group-pages" */ "./views/Advantages");
const HowItWorks = () => import(/* webpackChunkName: "group-pages" */ "./views/HowItWorks");
const HowToStart = () => import(/* webpackChunkName: "group-pages" */ "./views/HowToStart");
const Cookie = () => import(/* webpackChunkName: "group-pages" */ "./views/Cookie");
const Navigazione = () => import(/* webpackChunkName: "group-pages" */ "./views/Navigazione");

const DisableAccessNotification = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/DisableAccessNotification");
const DisableEmail = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/DisableEmail");
const LandingActivationAccount = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/LandingActivation");

// group-gallery
const EventIntro = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/event/Intro");
const EventDashboard = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/event/Dashboard");
const EventFavorites = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/event/Favorites");
const EventInfo = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/event/Info");
const GalleryAlbum = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/gallery/Album");
const GalleryCart = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/gallery/Cart");
const GalleryCheckout = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/gallery/Checkout");
const GalleryOrderConfirm = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/gallery/OrderConfirm");
const GalleryAlbumPhotos = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/gallery/AlbumPhotos");
const GalleryProject = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/gallery/Project");
const GalleryCustomizableProduct = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/gallery/CustomizableProduct");
const AccountProfile = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/account/Profile");
const AccountOrders = () =>
    import(/* webpackChunkName: "group-gallery" */ "./views/account/Orders");

// group-backend
const Contacts = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/Contacts");
const ContactRequest = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/ContactRequest");
const BackendLogin = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Login");
const BackendDashboard = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Dashboard");
const BackendGalleries = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Galleries");
const BackendGallery = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Gallery");
const BackendGalleryShare = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/GalleryShare");
const BackendGallerySettings = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/GallerySettings");
const BackendSearchProjects  = () => import(/* webpackChunkName: "group-backend" */ "./views/backend/SearchProjects");
const BackendShareProject = () => import(/* webpackChunkName: "group-backend" */ "./views/backend/ShareProject");

const BackendStudioContacts = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/studio/Contacts");
const BackendRecentGalleryActivities = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/RecentGalleryActivities");
const BackendSalesOrders = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/sales/Orders");
const BackendReportsVisitors = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/reports/Visitors");
    const BackendReportsEmail = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/reports/Email");
const BackendReportsVisitorsFavorites = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/reports/VisitorsFavorites");
const BackendTutorial = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Tutorial");
const BackendUserSettings = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/UserSettings");
const BackendSettings = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Settings");
const BackendPricelists = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/sales/Pricelists");
const BackendPricelist = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/sales/Pricelist");
const BackendInvoices = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/sales/Invoices");
const BackendWatermark = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Watermark");
const BackendAgents = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/Agents");
const BackendPrivacyConditions = () =>
    import(/* webpackChunkName: "group-backend" */ "./views/backend/PrivacyConditions");

const routes = [
    // FRONTEND ROUTES
    { path: "/", name: "home", component: Home, meta: { staticWebPage: true } },
    { path: "/caratteristiche.html", name: "features", component: Features, meta: { staticWebPage: true } },
    { path: "/vantaggi.html", name: "advantages", component: Advantages, meta: { staticWebPage: true } },
    { path: "/come-funziona.html", name: "page-howitworks", component: HowItWorks, meta: { staticWebPage: true } },
    { path: "/come-iniziare.html", name: "page-howtostart", component: HowToStart, meta: { staticWebPage: true } },
    { path: "/cookie", name: "cookie", component: Cookie, meta: { staticWebPage: true } },
    { path: "/navigazione", name: "navigazione", component: Navigazione, meta: { staticWebPage: true } },

    { path: "/contacts", name: "page-contacts", component: Contacts },
    { path: "/contact-request", name: "page-request-contact", component: ContactRequest },

    { path: "/account/activate/:activationKey", name: "landing-activation-account", component: LandingActivationAccount },
    { path: "/accesso", name: "eventcode", component: EventCode },
    { path: "/gallery/:galleryUrl", name: "gallery", component: EventIntro },
    {
        path: "/gallery/:galleryUrl/dashboard",
        name: "gallery-dashboard",
        component: EventDashboard,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/dashboard/customized",
        name: "gallery-dashboard-customized",
        component: EventDashboard,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/info",
        name: "gallery-info",
        component: EventInfo,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/favorites",
        name: "gallery-favorites",
        component: EventFavorites,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/cart",
        name: "gallery-cart",
        component: GalleryCart,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/checkout",
        name: "gallery-checkout",
        component: GalleryCheckout,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/order-confirm/:orderId",
        name: "gallery-order-confirm",
        component: GalleryOrderConfirm,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/album/:albumId",
        name: "gallery-album",
        component: GalleryAlbum,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/album/:albumId/photo/:photoId",
        name: "gallery-album-photo",
        component: GalleryAlbumPhotos,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/project/:projectId",
        name: "gallery-project",
        component: GalleryProject,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/customize/:albumId/:productDataBase64",
        name: "gallery-customizable-product",
        component: GalleryCustomizableProduct,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },

    {
        path: "/gallery/:galleryUrl/account/profile",
        name: "gallery-account-profile",
        component: AccountProfile,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/account/orders",
        name: "gallery-account-orders",
        component: AccountOrders,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/gallery/:galleryUrl/contacts",
        name: "gallery-contacts",
        component: Contacts,
        meta: { requiresAuth: true, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/disable-email/:idEventiEmail",
        name: "disable-email",
        component: DisableEmail,
        meta: { requiresAuth: false, gotoOnAuthFailed: "gallery" }
    },
    {
        path: "/disable-access-notification/:idEventiEmail",
        name: "disable-access-notification",
        component: DisableAccessNotification,
        meta: { requiresAuth: false, gotoOnAuthFailed: "gallery" }
    },

    // FRONTEND REDIRECTS
    { path: "/home", redirect: "/accesso" },
    { path: "/galleries/*", redirect: "/galleries" },
    { path: "/gallery/:galleryUrl/*", redirect: "/gallery/:galleryUrl" },

    // FRONTEND CATCH-ALL ROUTES
    { path: "*", redirect: "/" },

    // BACKEND ROUTES
    {
        path: "/backend",
        name: "backend",
        component: BackendLogin,
        meta: { requiresAuth: true, backendArea: true }
    },
    {
        path: "/backend/dashboard",
        name: "backend-dashboard",
        component: BackendDashboard,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/galleries",
        name: "backend-galleries",
        component: BackendGalleries,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    { path: "/backend/gallery", redirect: "/backend/galleries" },
    {
        path: "/backend/gallery/:eventId",
        name: "backend-gallery",
        component: BackendGallery,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/gallery/:eventId/share",
        name: "backend-gallery-share",
        component: BackendGalleryShare,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/gallery/:eventId/search-projects",
        name: "backend-gallery-search-projects",
        component: BackendSearchProjects,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/gallery/:eventId/share-project/:projectId",
        name: "backend-gallery-share-project",
        component: BackendShareProject,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/gallery/:eventId/settings",
        name: "backend-gallery-settings",
        component: BackendGallerySettings,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    { path: "/backend/studio", redirect: "/backend/dashboard" },
    {
        path: "/backend/studio/contacts",
        name: "backend-studio-contacts",
        component: BackendStudioContacts,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    { path: "/backend/sales", redirect: "/backend/dashboard" },
    {
        path: "/backend/recent-gallery-activities",
        name: "backend-recent-gallery-activities",
        component: BackendRecentGalleryActivities,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/sales/orders",
        name: "backend-sales-orders",
        component: BackendSalesOrders,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/sales/orders/:orderNum",
        name: "backend-sales-order",
        component: BackendSalesOrders,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/sales/pricelists",
        name: "backend-sales-pricelists",
        component: BackendPricelists,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/sales/pricelist/:pricelistId",
        name: "backend-sales-pricelist",
        component: BackendPricelist,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/sales/invoices",
        name: "backend-sales-invoices",
        component: BackendInvoices,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    { path: "/backend/reports", redirect: "/backend/dashboard" },
    {
        path: "/backend/reports/visitors",
        name: "backend-reports-visitors",
        component: BackendReportsVisitors,
        props: { mode: "visitors" },
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/reports/favorites",
        name: "backend-reports-favorites",
        component: BackendReportsVisitors,
        props: { mode: "favorites" },
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/reports/favorites/:eventId/:email",
        name: "backend-reports-favorites-details",
        component: BackendReportsVisitorsFavorites, // FIXME: rinominare in BackendReportsFavoritesDetails
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/reports/email",
        name: "backend-reports-email",
        component: BackendReportsEmail,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/tutorial",
        name: "backend-tutorial",
        component: BackendTutorial,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/user/settings",
        name: "backend-user-settings",
        component: BackendUserSettings,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/settings",
        name: "backend-settings",
        component: BackendSettings,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/watermark/:idWatermark",
        name: "backend-watermark",
        component: BackendWatermark,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/agents",
        name: "backend-agents",
        component: BackendAgents,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    },
    {
        path: "/backend/privacy",
        name: "backend-privacy-conditions",
        component: BackendPrivacyConditions,
        meta: {
            requiresAuth: true,
            backendArea: true,
            gotoOnAuthFailed: "backend"
        }
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
    }
});

// Authentication requirements for routes that requires authentication
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // match rotte frontend/backend che richiedono autenticazione
        var isAuthenticated = false;
        var action = "";

        switch(to.name) {
            case "backend-dashboard":
                if (to.query.bl) {
                    // passato parametro bl in query string con risposta dalla backendLogin da dominio differente
                    // qui è cambiato il dominio e quindi va memorizzata nuovamnete la risposta
                    var result =  JSON.parse(atob(to.query.bl))
                    store.commit("UPDATE_TOKEN_BE", result.token);
                    store.commit("UPDATE_USER_DATA_BE", result.user);
                }
                break;
            default:
                break;
        }

        if (to.meta.backendArea) {
            isAuthenticated = store.getters.isAuthenticatedBE;
            action = "EVENT_BACKEND_AUTH_CLEANUP";
        } else {
            isAuthenticated = store.getters.isAuthenticated;
            action = "EVENT_AUTH_CLEANUP";
        }

        if (!isAuthenticated) {
            store.dispatch(action);
            if (to.meta.gotoOnAuthFailed) {
                next({ name: to.meta.gotoOnAuthFailed, params: to.params });
            }
        }

        if (to.meta.backendArea && isAuthenticated && to.meta.gotoOnAuthFailed && !store.getters.hasAcceptedGDPR) {
            // se si tenta di accedere al backend senza aver accettato le clausole GDPR torna alla pagina di login
            next({ name: 'backend' });
        }
    }
    next();
});

export default router;
